<template>
  <div>
    <v-btn
      color="primary"
      small
      outlined
      :disabled="!disabledButton"
      @click="getInfoLevel(numberLevel)"
    >
      Nivel {{ numberLevel + 1 }}
    </v-btn>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title
              >Estadísticas - Nivel {{ numberLevel + 1 }}</v-toolbar-title
            >
            <v-spacer />
            <v-toolbar-items />
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12" sm="8">
                <v-subheader>Estadísticas del nivel</v-subheader>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="report_option"
                  :items="evaluations"
                  item-text="name"
                  item-value="value"
                  label="Seleccione evaluación"
                />
              </v-col>
              <v-col cols="12" class="mt-6">
                <base-material-card
                  icon="mdi-playlist-check"
                  :title="`Respuestas correctas - Nivel ${
                    numberLevel + 1
                  }`"
                  class="px-5 py-3"
                >
                  <v-data-table
                    :headers="headersTable1"
                    :items="dataTable1"
                    :hide-default-footer="true"
                  >
                    <template v-slot:[`item.lists`]="{ item }">
                      <v-menu offset-y :rounded="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            outlined
                            small
                            :disabled="[`item.lists`] < 1"
                            v-on="on"
                          >
                            Estudiantes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(student, index) in item.lists"
                            :key="index"
                          >
                            <v-list-item-title>{{ student }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </base-material-card>
              </v-col>
              <v-col cols="12" class="mt-6">
                <base-material-card
                  icon="mdi-timeline-clock-outline"
                  :title="`Promedio de 'tiempo de respuesta' por multiplicación - Nivel ${
                    numberLevel + 1
                  }`"
                  class="px-5 py-3"
                >
                  <v-data-table
                    :headers="headersTable2"
                    :items="dataTable2"
                    :hide-default-footer="true"
                  >
                    <template v-slot:[`item.lists`]="{ item }">
                      <v-menu offset-y :rounded="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            outlined
                            small
                            :disabled="[`item.lists`] < 1"
                            v-on="on"
                          >
                            Estudiantes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(student, index) in item.lists"
                            :key="index"
                          >
                            <v-list-item-title>{{ student }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </base-material-card>
              </v-col>
              <v-col cols="12" class="mt-6">
                <base-material-card
                  icon="mdi-timetable"
                  :title="`Promedio de 'tiempo de lectura' por cuadro texto - Nivel ${
                    numberLevel + 1
                  }`"
                  class="px-5 py-3"
                >
                  <v-data-table
                    :headers="headersTable3"
                    :items="dataTable3"
                    :hide-default-footer="true"
                  >
                    <template v-slot:[`item.lists`]="{ item }">
                      <v-menu offset-y :rounded="true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            v-bind="attrs"
                            outlined
                            small
                            :disabled="[`item.lists`] < 1"
                            v-on="on"
                          >
                            Estudiantes
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="(student, index) in item.lists"
                            :key="index"
                          >
                            <v-list-item-title>{{ student }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </base-material-card>
              </v-col>
            </v-row>
          </v-container>
          <v-divider />
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "LevelStatistics",
  props: {
    numberLevel: {
      type: Number,
      default: 0,
    },
    studentsGroup: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      report_option: 0,
      evaluations: [
        { name: "Evaluación #1", value: 0 },
        { name: "Evaluación #2", value: 1 },
      ],
      levelSelected: -1,
      dialog: false,
      studentsLevel: [],
      timeAnswers: [],
      timeReads: [],
      threshold: 0,
      avgCorrectAnswers: 0,
      avgTimeAnswersMultiplication: 0,
      avgTimeReadTextBox: 0,
      headersTable1: [
        {
          text: "",
          align: "start",
          value: "category",
          sortable: false,
        },
        {
          text: "Cantd. de Alumnos",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "Promedio respuestas correctas",
          value: "avg",
          align: "center",
          sortable: false,
        },
        {
          text: "Lista de Alumnos",
          value: "lists",
          align: "center",
          sortable: false,
        },
      ],
      dataTable1: [
        {
          category: "20 - 18 respuestas correctas",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "12 - 17 respuestas correctas",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "0 - 11 respuestas correctas",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "Todos",
          count: 0,
          avg: 0,
          lists: [],
        },
      ],
      headersTable2: [
        {
          text: "Subgrupo",
          align: "start",
          value: "category",
          sortable: false,
        },
        {
          text: "Cantd. de Alumnos",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "Promedio de tiempo (seg.)",
          value: "avg",
          align: "center",
          sortable: false,
        },
        {
          text: "Lista de Alumnos",
          value: "lists",
          align: "center",
          sortable: false,
        },
      ],
      dataTable2: [
        {
          category: "20% de alumnos con menores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "Grupo medio",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "20% de alumnos con mayores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "Grupo",
          count: 0,
          avg: 0,
          lists: [],
        },
      ],
      headersTable3: [
        {
          text: "Subgrupo",
          align: "start",
          value: "category",
          sortable: false,
        },
        {
          text: "Cantd. de Alumnos",
          value: "count",
          align: "center",
          sortable: false,
        },
        {
          text: "Promedio de tiempo (seg.)",
          value: "avg",
          align: "center",
          sortable: false,
        },
        {
          text: "Lista de Alumnos",
          value: "lists",
          align: "center",
          sortable: false,
        },
      ],
      dataTable3: [
        {
          category: "20% de alumnos con menores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "Grupo medio",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "20% de alumnos con mayores tiempos",
          count: 0,
          avg: 0,
          lists: [],
        },
        {
          category: "Grupo",
          count: 0,
          avg: 0,
          lists: [],
        },
      ],
    };
  },
  computed: {
    ...mapState(["userData"]),
    disabledButton() {

      this.studentsGroup.forEach((student) => 
      {
          if(!!student.episode1 && !!student.episode1.levels[`010${this.numberLevel + 1}`] )
            return false
      });
      

      // let maxLevel = this.studentsGroup.filter( (d) => 
      // {
      //   if(!d.episode1) continue

      //   d.episode1.levels[`010${this.numberLevel + 1}`]
      // }).length 

      return true;
    },
    countStudent() {
      return this.studentsLevel.length;
    },
  },
  watch: {
    report_option(value) {

      this.report_option = value;

      this.buildStudentsArray();

      this.processData();

      this.disabledButton;
    },
  },
  methods: {
    getInfoLevel(level) {

      this.levelSelected = level;
      this.$store.commit("SET_LOADING", true);
      
      this.buildStudentsArray();

      this.processData();
    },
    buildStudentsArray()
    {
      this.studentsLevel = [];
      const students = this.studentsGroup.filter(
        (d) => d.episode1.levels[`010${this.levelSelected + 1}`]
      );
      students.forEach((student) => {
        var _student = Object.assign({}, student.episode1.levels[`010${this.levelSelected + 1}`]);
        _student['name'] = student.name;

        if(_student[this.report_option])
          this.studentsLevel.push(_student);
      });

      //console.log("student count level "+this.numberLevel+": "+this.countStudent);
    },
    processData() {
      this.dataTable1.map((t) => {
        t.count = 0;
        t.avg = 0;
        t.lists = [];
      });
      this.dataTable2.map((t) => {
        t.count = 0;
        t.avg = 0;
        t.lists = [];
      });
      this.dataTable3.map((t) => {
        t.count = 0;
        t.avg = 0;
        t.lists = [];
      });
      this.avgCorrectAnswers = 0;
      this.avgTimeAnswersMultiplication = 0;
      this.avgTimeReadTextBox = 0;

      this.threshold = Math.floor((this.studentsLevel.length * 0.2) + 0.5);
      //this.threshold = Math.ceil(this.studentsLevel.length * 0.2);

      console.log("studentCount >> "+this.studentsLevel.length+", threshold >>"+this.threshold);

      this.timeAnswers = [];
      this.timeReads = [];

      this.studentsLevel.forEach((student) => 
      {
        if (!student[this.report_option]) {
          console.log("No hay data para la evaluación seleccionada");
          //this.clearData();
          return;
        }
      
        const correct = student.totalCorrectEvaluation[this.report_option]
          ? student.totalCorrectEvaluation[this.report_option] : 0;
        this.avgCorrectAnswers += correct;
        //this.avgCorrectAnswers /= this.countStudent;

        const timeAnswersMultiplication = student.solveTimeEvaluation[ this.report_option ]
          ? student.solveTimeEvaluation[this.report_option] : 0;
        this.avgTimeAnswersMultiplication += timeAnswersMultiplication;

        this.timeAnswers.push(timeAnswersMultiplication.toFixed(2));

        const timeReadTexts = student.storyTimeEvaluation[ this.report_option ] ? 
            student.storyTimeEvaluation[ this.report_option ] : 0;
        this.avgTimeReadTextBox += timeReadTexts;

        this.timeReads.push(timeReadTexts.toFixed(2));
      });

      console.log("Reporte "+this.report_option+" - tiempo de lectura promedio total: "+this.avgTimeReadTextBox);

      this.timeAnswers.sort((a, b) => b - a);
      this.timeReads.sort((a, b) => b - a);

      if(this.countStudent > 0)
      {

        this.dataTable1[3].count = this.countStudent;
        this.dataTable2[3].count = this.countStudent;
        this.dataTable3[3].count = this.countStudent;

        //group-level average correct
        this.dataTable1[3].avg = parseFloat(
          this.avgCorrectAnswers / this.countStudent
        ).toFixed(2);

        //group-level average time multiplication
        this.dataTable2[3].avg = parseFloat(
          this.avgTimeAnswersMultiplication / this.countStudent
        ).toFixed(2);

        //group-level average time read
        this.dataTable3[3].avg = parseFloat(
          this.avgTimeReadTextBox / this.countStudent
        ).toFixed(2);
      }

      //sum all times
      this.studentsLevel.forEach((student) => {
        this.correctAnswers(student);
        this.levelsSolveTime(student);
        this.levelsStoryTime(student);
      });

      //average
      this.averageTable(this.dataTable1);
      this.averageTable(this.dataTable2);
      this.averageTable(this.dataTable3);

      this.$store.commit("SET_LOADING", false);
      this.dialog = true;
    },
    averageTable(table) {
      if (table[2].count > 0)
        table[2].avg = (table[2].avg / parseFloat(table[2].count)).toFixed(2);

      if (table[1].count > 0)
        table[1].avg = (table[1].avg / parseFloat(table[1].count)).toFixed(2);

      if (table[0].count > 0) {
        table[0].avg = (table[0].avg / parseFloat(table[0].count)).toFixed(2);
      }
    },
    correctAnswers(st) {
      const correct = st.totalCorrectEvaluation[this.report_option]
        ? st.totalCorrectEvaluation[this.report_option]
        : 0
      this.dataTable1[3].lists.push(st.name);

      switch (true) {
        case correct <= 11.5:
          {
            this.dataTable1[2].count++;
            this.dataTable1[2].avg += parseFloat(correct);
            this.dataTable1[2].lists.push(st.name);
          }
          break;
        case correct <= 17.5:
          {
            this.dataTable1[1].count++;
            this.dataTable1[1].avg += parseFloat(correct);
            this.dataTable1[1].lists.push(st.name);
          }
          break;
        case correct <= 20:
          {
            this.dataTable1[0].count++;
            this.dataTable1[0].avg += parseFloat(correct);
            this.dataTable1[0].lists.push(st.name);
          }
          break;
      }
    },
    levelsSolveTime(st) {
      const solveTime = st.solveTimeEvaluation[this.report_option]
        ? st.solveTimeEvaluation[this.report_option].toFixed(2)
        : 0
      const currentIndex = this.timeAnswers.indexOf(solveTime);
      this.dataTable2[3].lists.push(st.name);

      switch (true) {
         case currentIndex > this.timeAnswers.length - this.threshold - 1: {
          this.dataTable2[0].count++;
          this.dataTable2[0].avg += parseFloat(solveTime);
          this.dataTable2[0].lists.push(st.name);
          break;
        }
        case currentIndex < this.threshold: {
          this.dataTable2[2].count++;
          this.dataTable2[2].avg += parseFloat(solveTime);
          this.dataTable2[2].lists.push(st.name);
          break;
        }
        default: {
          this.dataTable2[1].count++;
          this.dataTable2[1].avg += parseFloat(solveTime);
          this.dataTable2[1].lists.push(st.name);
          break;
        }
      }
    },
    levelsStoryTime(st) {
      const storyTime = st.storyTimeEvaluation[this.report_option]
        ? st.storyTimeEvaluation[this.report_option].toFixed(2) : 0

      const currentIndex = this.timeReads.indexOf(storyTime);
      this.dataTable3[3].lists.push(st.name);

      console.log(st.name + " - storyTime: "+storyTime+", index: "+currentIndex );

      switch (true) {
        case currentIndex > this.timeReads.length - this.threshold - 1: {
          this.dataTable3[0].count++;
          this.dataTable3[0].avg += parseFloat(storyTime);
          this.dataTable3[0].lists.push(st.name);
          break;
        }
        case currentIndex < this.threshold: {
          this.dataTable3[2].count++;
          this.dataTable3[2].avg += parseFloat(storyTime);
          this.dataTable3[2].lists.push(st.name);
          break;
        }
        default: {
          this.dataTable3[1].count++;
          this.dataTable3[1].avg += parseFloat(storyTime);
          this.dataTable3[1].lists.push(st.name);
          break;
        }
      }
    },
  },
};
</script>
